import LegacyChannelInfo from "./LegacyChannelInfo";
import LegacyNotificationChannelTypeId from "./LegacyNotificationChannelTypeId";

export default class LegacyNotificationChannel {
    public id: string;
    public notificationChannelTypeId = LegacyNotificationChannelTypeId.Webhook;
    public isDefault = false;
    public isEnabled = false;
    public channel = new LegacyChannelInfo();
}



// WEBPACK FOOTER //
// ./src/modules/organization/models/LegacyNotificationChannel.ts